// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/app/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 't__plugin-layout__Layout' */'/app/src/.umi-production/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/user",
        "layout": false,
        "routes": [
          {
            "name": "login",
            "path": "/user/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LoginPage' */'/app/src/pages/LoginPage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/app/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__RootLayout' */'@/layouts/RootLayout'), loading: LoadingComponent}),
        "layout": false,
        "flatMenu": true,
        "routes": [
          {
            "path": "/",
            "redirect": "/home",
            "name": "homePage",
            "exact": true
          },
          {
            "path": "/home",
            "name": "homePage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__IndexPage__HomePage' */'/app/src/pages/IndexPage/HomePage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/mine",
            "name": "minePage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__IndexPage__MinePage' */'/app/src/pages/IndexPage/MinePage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/juveniles_block_reports",
            "name": "JuvenilesBlockReportListPage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__IndexPage__JuvenilesBlockReportListPage' */'/app/src/pages/IndexPage/JuvenilesBlockReportListPage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/management_standards",
            "name": "ManagementStandardListPage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__IndexPage__ManagementStandardListPage' */'/app/src/pages/IndexPage/ManagementStandardListPage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/companies_map",
            "name": "CompaniesMapPage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompaniesMapPage' */'/app/src/pages/CompaniesMapPage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/juveniles_block_report_new",
            "name": "JuvenilesBlockReportNewPage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__JuvenilesBlockReportFormPage' */'/app/src/pages/JuvenilesBlockReportFormPage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'@/layouts/BasicLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/pufaxuanchuan",
                "name": "pufaxuanchuanPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PufaxuanchuanPage' */'/app/src/pages/PufaxuanchuanPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/messages",
                "name": "messageListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MessageListPage' */'/app/src/pages/MessageListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_staffs",
                "name": "companyStaffListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyStaffListPage' */'/app/src/pages/CompanyStaffListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_staff_new",
                "name": "companyStaffNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyStaffFormPage' */'/app/src/pages/CompanyStaffFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_staff_edit/:id",
                "name": "companyStaffEditPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyStaffFormPage' */'/app/src/pages/CompanyStaffFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/sign_in",
                "name": "signInPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SignInPage' */'/app/src/pages/SignInPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/attendance_records",
                "name": "AttendanceRecordListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AttendanceRecordListPage' */'/app/src/pages/AttendanceRecordListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/attendance_record_new",
                "name": "AttendanceRecordNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AttendanceRecordFormPage' */'/app/src/pages/AttendanceRecordFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/attendance_record_location",
                "name": "AttendanceRecordLocationPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AttendanceRecordLocationPage' */'/app/src/pages/AttendanceRecordLocationPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_feedback_records",
                "name": "CompanyFeedbackRecordListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyFeedbackRecordListPage' */'/app/src/pages/CompanyFeedbackRecordListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_monitors",
                "name": "CompanyMonitorListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyMonitorListPage' */'/app/src/pages/CompanyMonitorListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_monitors/:id/play",
                "name": "CompanyMonitorPlayPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyMonitorPlayPage' */'/app/src/pages/CompanyMonitorPlayPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_manage",
                "name": "CompanyManagePage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyManagePage' */'/app/src/pages/CompanyManagePage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_update",
                "name": "CompanyUpdatePage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyUpdatePage' */'/app/src/pages/CompanyUpdatePage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/licenses",
                "name": "LicenseListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LicenseListPage' */'/app/src/pages/LicenseListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/license_new",
                "name": "LicenseNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LicenseFormPage' */'/app/src/pages/LicenseFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/license_edit/:id",
                "name": "LicenseEditPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LicenseFormPage' */'/app/src/pages/LicenseFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/map_select",
                "name": "MapSelectPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MapSelectPage' */'/app/src/pages/MapSelectPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/self_audit_settings",
                "name": "SelfAuditSettingListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfAuditSettingListPage' */'/app/src/pages/SelfAuditSettingListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/self_audit_record_new/:setting_id",
                "name": "SelfAuditRecordNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfAuditRecordNewPage' */'/app/src/pages/SelfAuditRecordNewPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/self_audit_records/:id",
                "name": "SelfAuditRecordShowPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfAuditRecordShowPage' */'/app/src/pages/SelfAuditRecordShowPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/self_audit_records",
                "name": "SelfAuditRecordListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SelfAuditRecordListPage' */'/app/src/pages/SelfAuditRecordListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_select",
                "name": "CompanySelectPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanySelectPage' */'/app/src/pages/CompanySelectPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_form_select",
                "name": "CompanyFormSelectPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyFormSelectPage' */'/app/src/pages/CompanyFormSelectPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/articles/:id",
                "name": "ArticleShowPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ArticleShowPage' */'/app/src/pages/ArticleShowPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/iot_hardwares",
                "name": "IotHardwareListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__IotHardwareListPage' */'/app/src/pages/IotHardwareListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/iot_hardware_new",
                "name": "IotHardwareNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__IotHardwareFormPage' */'/app/src/pages/IotHardwareFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/rectification_records",
                "name": "RectificationRecordListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RectificationRecordListPage' */'/app/src/pages/RectificationRecordListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/rectification_records/:id/detail",
                "name": "RectificationRecordDetailPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RectificationRecordDetailPage' */'/app/src/pages/RectificationRecordDetailPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/rectification_and_reporting/:id",
                "name": "RectificationAndReportingPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__RectificationAndReportingPage' */'/app/src/pages/RectificationAndReportingPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/feedback_records",
                "name": "FeedbackRecordListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__FeedbackRecordListPage' */'/app/src/pages/FeedbackRecordListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/feedback_record_new",
                "name": "FeedbackRecordNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__FeedbackRecordFormPage' */'/app/src/pages/FeedbackRecordFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_staff_join_apply_new",
                "name": "CompanyStaffJoinApplyNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyStaffJoinApplyNewPage' */'/app/src/pages/CompanyStaffJoinApplyNewPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_staff_resign_apply_new",
                "name": "CompanyStaffResignApplyNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyStaffResignApplyNewPage' */'/app/src/pages/CompanyStaffResignApplyNewPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_services",
                "name": "CompanyServiceListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyServiceListPage' */'/app/src/pages/CompanyServiceListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_service_new",
                "name": "CompanyServiceNewPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyServiceFormPage' */'/app/src/pages/CompanyServiceFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_score_operate_records",
                "name": "CompanyScoreOperateRecordListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyScoreOperateRecordListPage' */'/app/src/pages/CompanyScoreOperateRecordListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/company_score_operate_records/:company_score_operate_record_id/create_rectification_record",
                "name": "CompanyScoreOperateRecordCreateRectificationRecordFormPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyScoreOperateRecordCreateRectificationRecordFormPage' */'/app/src/pages/CompanyScoreOperateRecordCreateRectificationRecordFormPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/companies/:id/detail",
                "name": "CompanyDetailPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CompanyDetailPage' */'/app/src/pages/CompanyDetailPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/announcement_records",
                "name": "AnnouncementRecordListPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AnnouncementRecordListPage' */'/app/src/pages/AnnouncementRecordListPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/announcement_records/:id/detail",
                "name": "AnnouncementRecordDetailPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AnnouncementRecordDetailPage' */'/app/src/pages/AnnouncementRecordDetailPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/management_standards/:id/detail",
                "name": "ManagementStandardDetailPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ManagementStandardDetailPage' */'/app/src/pages/ManagementStandardDetailPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/law_study_plans/:id/detail",
                "name": "LawStudyPlanDetailPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LawStudyPlanDetailPage' */'/app/src/pages/LawStudyPlanDetailPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/law_exams/:id/detail",
                "name": "LawExamDetailPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LawExamDetailPage' */'/app/src/pages/LawExamDetailPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/law_exams/:id/take",
                "name": "LawExamTakePage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LawExamTakePage' */'/app/src/pages/LawExamTakePage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/law_exam_records/:id",
                "name": "LawExamRecordDetailPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LawExamRecordDetailPage' */'/app/src/pages/LawExamRecordDetailPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/user_setting",
                "name": "UserSettingPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__UserSettingPage' */'/app/src/pages/UserSettingPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/result",
                "name": "ResultPage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ResultPage' */'/app/src/pages/ResultPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/app/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
